import React from 'react';

const TwitterPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fab fa-twitter"></i>
          Twitter - @MarcoPDeMarco
        </h1>
        <p>Follow me on Twitter for quick updates, thoughts, and conversations.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="social-content">
            <p className="welcome-text">
              Twitter is where I share quick thoughts, interesting articles,
              and engage in conversations about family, heritage, current events,
              and topics that matter to me.
            </p>

            {/* Twitter Timeline Embed */}
            <div className="twitter-embed">
              <h3>Latest Tweets</h3>
              <div className="social-embed-container">
                <a 
                  className="twitter-timeline" 
                  data-height="500" 
                  data-theme="light" 
                  href="https://twitter.com/MarcoPDeMarco?ref_src=twsrc%5Etfw"
                >
                  Tweets by MarcoPDeMarco
                </a>
                <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"></script>
              </div>
            </div>

            {/* What to Expect */}
            <div className="content-preview">
              <h3>What You'll Find on My Twitter</h3>
              <div className="social-features">
                <div className="feature-item">
                  <i className="fas fa-lightbulb"></i>
                  <h4>Quick Thoughts</h4>
                  <p>Brief reflections on daily life, family, and experiences</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-share"></i>
                  <h4>Interesting Shares</h4>
                  <p>Articles, news, and content related to heritage and family history</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-reply"></i>
                  <h4>Conversations</h4>
                  <p>Engaging discussions about topics that matter to our community</p>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-clock"></i>
                  <h4>Real-time Updates</h4>
                  <p>Live updates from events, travels, and family gatherings</p>
                </div>
              </div>
            </div>

            {/* Direct Link */}
            <div className="social-link-section">
              <h3>Follow Me on Twitter</h3>
              <a 
                href="https://twitter.com/MarcoPDeMarco" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-platform-link twitter-link"
              >
                <i className="fab fa-twitter"></i>
                Follow @MarcoPDeMarco
              </a>
              <p className="link-description">
                Click above to follow me on Twitter and join the conversation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwitterPage;